import { HttpClient, HttpParams } from "@angular/common/http";
import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { TranslateService } from "@root/shared/service/translate.service";
import _ from "lodash";
import { NzModalService } from "ng-zorro-antd/modal";
import { NzMessageService } from "ng-zorro-antd/message";
import { UntypedFormBuilder, UntypedFormGroup } from "@angular/forms";

@Component({
  selector: "v4-common-deposit-list",
  templateUrl: "./deposit.component.html",
  styleUrls: ["./deposit.component.scss"],
})
export class V4CommonDepositListComponent implements OnInit {
  // private readonly ListApi = '/api/deposit/list';
  private readonly DeducteApi = "/api/deposit/deduct";
  private readonly RefundApi = "/api/deposit/refund";
  tabType: "paid" | "wait_pay" | "refunded" = "paid";
  @Input() page = 1;
  @Input() pageSize = 20;
  @Input() total = 0;
  @Input() listOfDeposit = [];
  @Output() onClickRow = new EventEmitter<string>();
  @Output() onChange = new EventEmitter();
  @Output() onPageChange = new EventEmitter();

  // currentDeposit;
  deductForm: UntypedFormGroup = this.fb.group({
    reservation_code: null,
    amount: 0, // 待扣除
    paid: 0, // 已收
    deposit_currency: "",
  });
  constructor(
    private http: HttpClient,
    private modal: NzModalService,
    private msgSrv: NzMessageService,
    private t: TranslateService,
    private fb: UntypedFormBuilder
  ) {}

  ngOnInit() {
    // this.fetchDepositList();
  }

  // fetchDepositList () {
  //   const { page, pageSize, tabType } = this;
  //   const obj = {
  //     page: `${page}`,
  //     page_size: `${pageSize}`,
  //     tab_type: tabType,
  //   };
  //   const query = new HttpParams({
  //     fromObject: obj
  //   });
  //   this.http.get(this.ListApi, { params: query }).subscribe(rst => {
  //     this.listOfDeposit = _.get(rst, 'data.list');
  //     this.total = _.get(rst, 'data.count');
  //     console.log('rst: ', rst);
  //   });
  // }

  requestDeducte() {
    const value = this.deductForm.value;
    // if (this.currentDeposit.waitDeductedDeposit < 0) {
    if (value.amount < 0) {
      // return this.msgSrv.warning('不可输入负数');
      return this.msgSrv.warning(this.t.t("deposit.list.deduct.toast.negative_waring"));
    }

    const params = {
      reservation_code: value.reservation_code,
      amount: value.amount,
    };

    // const params = {
    //   reservation_code: this.currentDeposit.code,
    //   amount: this.currentDeposit.waitDeductedDeposit
    // };
    this.http.post(this.DeducteApi, params).subscribe((rst: any) => {
      if (rst.error_code === 0) {
        // this.msgSrv.success('押金已退');
        this.onChange.emit();
        // this.fetchDepositList();
      }
    });
  }

  requestRefund(code) {
    this.http.post(this.RefundApi, { reservation_code: code }).subscribe((rst: any) => {
      if (rst.error_code === 0) {
        // this.msgSrv.success('押金已退');
        this.msgSrv.success(this.t.t("deposit.list.refund.toast.success"));
        this.onChange.emit();
        // this.fetchDepositList();
      }
    });
  }

  displayDeducteModal(tpl, data) {
    this.deductForm.patchValue({
      reservation_code: data.code,
      amount: data.deducted || 0,
      paid: data.paid,
      deposit_currency: data.deposit_currency,
    });
    // this.currentDeposit = data;
    // this.currentDeposit.waitDeductedDeposit = data.deducted || 0;
    this.modal.create({
      // nzTitle: '扣押金',
      nzTitle: this.t.t("deposit.list.deduct.modal.title"),
      nzContent: tpl,
      // nzOkText: '保存',
      nzOkText: this.t.t("word.save"),
      nzOnOk: () => this.requestDeducte(),
    });
  }

  displayRefundModal(data) {
    // this.currentDeposit = data;
    this.modal.confirm({
      // nzTitle: '确认立即退还押金？',
      nzTitle: this.t.t("deposit.list.refund.modal.title"),
      // nzContent: `即将退还押金${data.pending_refund}`,
      nzContent: this.t.t("deposit.list.refund.modal.content", {
        number: data.pending_refund,
      }),
      nzOnOk: () => this.requestRefund(data.code),
    });
  }

  // onPageChange() {
  //   this.onChange.emit();
  //   // this.fetchDepositList();
  // }
}
